import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaSearch, FaShoppingCart, FaThLarge, FaUserCircle } from "react-icons/fa";
import { FiHeart, FiShoppingCart, FiUser } from "react-icons/fi";
import { HiOutlineShoppingCart, HiOutlineUser } from "react-icons/hi";
import Logo from "../assets/logo.png";
import Bottomlogo from "../assets/bottomlogo.png";
import { makeRequest } from "../services/api";
import { webEndPoint } from '../constants/globalConstants';
export default function Header() {
    const location = useLocation();
    const wishlistCount = 0;
    const cartCount = 0;
    const iconStyle = {
        strokeWidth: 1.5
    };
    const token = localStorage.getItem("userToken");
    const [loading, setLoading] = useState(false);
    const [cartData, setCartData] = useState([]);
    useEffect(() => {
        if (!token) {
            return;
        } else {
            fetchCartData();
        }
    }, []);
    const fetchCartData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "cart/count/" + localStorage.getItem("userID");
            const response = await makeRequest("get", url);
            if (response) {
                setCartData(response.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <header class="header desktop-header">
                <div class="logo"><a href="/"><img src={Logo}></img></a></div>
                <div class="search-bar"><input type="text" placeholder="Search products..." /><button><FaSearch color="white" size={16} /></button></div>
                <nav className="nav-icons" style={{ display: "flex", gap: "25px", alignItems: "center" }}>
                    <Link to={token ? "/user-dashboard" : "/signin"} className={location.pathname === "/signin" ? "active" : ""} title="Account" style={{ color: "black" }}>
                        <FiUser size={22} />
                    </Link>
                    <Link to={token ? "/cart" : "/signin"} className={location.pathname === "/cart" ? "active" : ""} title="Cart" style={{ color: "black", position: "relative" }}>
                        <FiShoppingCart size={22} />
                        {cartData?.unique_items > 0 && (
                            <span style={{ position: "absolute", top: "-12px", right: "-10px", background: "#e05da3", color: "white", borderRadius: "50%", padding: "2px 6px", fontSize: "12px", fontWeight: "600", }}>{cartData?.unique_items}</span>
                        )}
                    </Link>
                </nav>
            </header>

            <header className="mobile-top-header">
                <div className="mobile-header-row">
                    <div className="mobile-logo">
                        <a href="/"><img src={Logo} /></a>
                    </div>
                    <div className="bottomlogo">
                        <img src={Bottomlogo} alt="bottom logo" />
                    </div>
                    <div className="mobile-cart">
                        <Link to="/signin">
                            <HiOutlineUser size={22} style={iconStyle} />
                        </Link>
                        <Link to="/cart" style={{ position: "relative", marginLeft: "10px" }}>
                            <HiOutlineShoppingCart size={22} style={iconStyle} />
                            {/* {cartCount > 0 && <span className="cart-count">{cartCount}</span>} */}
                            {Number(cartData?.unique_items) > 0 && (
                                <span className="cart-count">
                                    {cartData.unique_items}
                                </span>
                            )}
                        </Link>
                    </div>
                </div>
                <div>
                    <div className="mobile-search-bar">
                        <input type="text" placeholder="Search products..." />
                        <button>
                            <FaSearch color="white" size={16} />
                        </button>
                    </div>
                </div>
            </header>
        </>
    );
}